var _path, _path2, _ellipse, _g, _g2, _g3, _g4, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _g5, _g6, _path1, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError404(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 369,
    viewBox: "0 0 191 369",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.9494 257.128C98.7642 257.192 98.5738 257.25 98.3849 257.302C92.7161 258.85 3.00057 282.617 3 235.943C2.99941 187.746 38.3439 150.677 91.6206 151.002L104.483 151.081C140.001 151.298 168.791 187.12 173.151 211.481C177.51 235.843 175.02 252.217 156.333 254.72C137.647 257.224 98.6654 247.209 103.026 237.82C107.386 228.431 156.039 230.935 156.921 230.875C157.804 230.815 148.492 221.615 145.828 221.599C143.165 221.583 140.992 228.33 140.977 230.816L140.259 349.049C140.251 350.415 139.322 351.604 137.996 351.926C121.25 355.992 103.666 358.106 85.5381 357.996C72.0709 357.914 60.2395 356.607 47.6807 354.19C46.2717 353.919 45.2636 352.677 45.2726 351.242L45.967 241.68C45.9845 238.781 43.8443 231.216 40.7364 231.197C39.3578 231.188 28.5051 237.194 28.5051 240.324C28.5051 243.454 84.9617 234.065 103.026 229.057C121.019 224.069 122.943 248.892 98.9494 257.128Z",
    fill: "#5C4691"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M148.789 69.7669C151.57 103.927 126.52 133.515 92.8357 135.853C59.152 138.19 27.9813 112.384 25.1995 78.2235C22.4179 44.0631 49.0784 14.4851 82.7619 12.1472C116.446 9.8092 146.007 35.6064 148.789 69.7669Z",
    fill: "#5C4691"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 81.5,
    cy: 114,
    rx: 10.5,
    ry: 8,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1_33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.4798 225.219V249.585M85.4798 225.219L104.216 254.234M85.4798 225.219L83.8153 208M85.4798 225.219L67 230.859L85.4798 249.585M85.4798 225.219L121.287 214.759L104.216 254.234M85.4798 249.585L104.216 254.234M85.4798 249.585L104.216 269M104.216 254.234L125 247.217",
    stroke: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1_33)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 225,
    r: 4,
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1_33)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 254,
    r: 5,
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1_33)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 85.5,
    cy: 249.5,
    r: 5.5,
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.635 206.071C94.635 209.976 91.4663 213.141 87.5575 213.141C83.6487 213.141 80.48 209.976 80.48 206.071C80.48 202.166 83.6487 199 87.5575 199C91.4663 199 94.635 202.166 94.635 206.071Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2113 229.011C75.2113 232.656 72.2538 235.611 68.6056 235.611C64.9574 235.611 62 232.656 62 229.011C62 225.367 64.9574 222.412 68.6056 222.412C72.2538 222.412 75.2113 225.367 75.2113 229.011Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M124.754 215.813C124.754 219.457 121.796 222.412 118.148 222.412C114.5 222.412 111.542 219.457 111.542 215.813C111.542 212.168 114.5 209.213 118.148 209.213C121.796 209.213 124.754 212.168 124.754 215.813Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M129 244.528C129 248.541 125.743 251.795 121.726 251.795C117.709 251.795 114.452 248.541 114.452 244.528C114.452 240.514 117.709 237.26 121.726 237.26C125.743 237.26 129 240.514 129 244.528Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M109.891 262.558C109.891 266.116 107.004 269 103.442 269C99.8812 269 96.9941 266.116 96.9941 262.558C96.9941 259 99.8812 256.116 103.442 256.116C107.004 256.116 109.891 259 109.891 262.558Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M110.599 233.921C110.599 240.278 105.441 245.431 99.078 245.431C92.7154 245.431 87.5575 240.278 87.5575 233.921C87.5575 227.565 92.7154 222.412 99.078 222.412C105.441 222.412 110.599 227.565 110.599 233.921Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2441 253.327C80.2441 257.34 76.9874 260.594 72.9701 260.594C68.9527 260.594 65.696 257.34 65.696 253.327C65.696 249.313 68.9527 246.059 72.9701 246.059C76.9874 246.059 80.2441 249.313 80.2441 253.327Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7217 205L119.296 213.982M86.7217 205L68 229.35M86.7217 205L99.8188 235.546M119.296 213.982L123 244.583M119.296 213.982L99.8188 235.546M123 244.583L103.796 264M123 244.583L99.8188 235.546M103.796 264L72.2184 255.041M103.796 264L99.8188 235.546M72.2184 255.041L68 229.35M72.2184 255.041L99.8188 235.546M68 229.35L99.8188 235.546",
    stroke: "white",
    strokeWidth: 3
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_1_33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.1743 230.2C69.9156 231.84 50.6414 239.622 41.8679 241.501C39.1522 248.334 36.5757 263.087 43.0932 263.907C51.2401 264.932 69.1009 257.303 77.8744 248.078C83.236 242.441 77.2473 228.15 73.1743 230.2Z",
    fill: "#5C4691"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_1_33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.68 219.245C125.494 221.342 137.913 229.885 145.491 232.289C147.836 241.029 155.628 253.677 149.999 254.726C142.963 256.037 127.152 252.787 116.912 241.745C111.417 235.819 119.162 216.623 122.68 219.245Z",
    fill: "#5C4691"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M102 229L104.925 222.946L106 224L104 230.5L98.5001 233.5L100.5 241L93.9998 245.5L92.4998 245L98.5001 239.5L96.5001 233L102 229Z",
    fill: "#5C4691"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M106.5 213.5L105.5 206.5L107 206L107.5 213.5H106.5Z",
    fill: "#5C4691"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M83 259L86 257L84 256.5L81 258L80.5 260L82.5 260.5L83 259Z",
    fill: "#5C4691"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_33",
    x: 64.0637,
    y: 205.952,
    width: 63.0963,
    height: 65.3953,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_1_33"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1_33",
    x: 80,
    y: 219,
    width: 12,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_1_33"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1_33",
    x: 98,
    y: 247,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_1_33"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1_33",
    x: 78,
    y: 242,
    width: 15,
    height: 15,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_1_33"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1_33",
    x: 39,
    y: 229,
    width: 53,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_33"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_33",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_1_33",
    x: 100,
    y: 219,
    width: 52.0002,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -11,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_33"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_33",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError404);
export default __webpack_public_path__ + "static/media/error_404.6dbf50b7e41f9a88a4b27aab2ae20502.svg";
export { ForwardRef as ReactComponent };